import React from "react";
import dayjs from "dayjs";
import AppDatePicker from "../../../components-ui/AppDatePicker";
import { PersonDetails } from "../../../types/types";

interface Props {
  details: PersonDetails;
  onChange: (details: PersonDetails) => void;
  title?: string;
  requireName?: boolean;
}

export default function PartyDetailsCard({ details, onChange, title = "Personal Details", requireName = false }: Props) {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) =>
    onChange({ ...details, [event.target.name]: event.target.value });

  return (
    <div className="card">
      <div className="card-header">
        <div className="card-title">{title}</div>
      </div>
      <div className="form-row">
        <div className="form-group">
          <label className="form-label">First Name</label>
          <input className="form-input" type="text" name="firstName" value={details.firstName} onChange={handleChange} required={requireName} />
        </div>
        <div className="form-group">
          <label className="form-label">Last Name</label>
          <input className="form-input" type="text" name="lastName" value={details.lastName} onChange={handleChange} required={requireName} />
        </div>
      </div>
      <div className="form-row">
        <div className="form-group">
          <label className="form-label">Date of Birth</label>
          <AppDatePicker value={details.dateOfBirth} maxDate={dayjs()} onChange={(value) => onChange({ ...details, dateOfBirth: value ?? "" })} />
        </div>
        <div className="form-group">
          <label className="form-label">Gender</label>
          <select className="form-input" name="gender" value={details.gender || ""} onChange={handleChange}>
            <option value="">Select Gender</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Other">Other</option>
          </select>
        </div>
      </div>
    </div>
  );
}
